export const getFileExtension = (response) => {
    const type = response.headers.get("content-type")
    const from = type.search("/") + 1
    const to = type.search(";charset")
    return type.substring(from, to)
}

export const getFileNameAndExtension = (disposition) => {
    if (disposition && disposition.indexOf('filename=') !== -1) {
        return disposition.split('filename=')[1].replace(/"/g, '');
    } else {
        return 'downloaded-file'
    }
}
export const getFileNameAndExtensionWithMaterial = (disposition, nameMaterial) => {
    if (disposition && disposition.indexOf('filename=') !== -1) {
        const nameAndExtension = disposition.split('filename=')[1].split('.')
        return `${nameAndExtension[0]}_${nameMaterial.split(" ").filter(Boolean).join("_")}.${nameAndExtension[1]}`
    } else {
        return 'downloaded-file'
    }
}